import { asyncAction } from '@/lib/action';

export const getMessagesAction = asyncAction('messages/GET_MESSAGES');
export const disableMessageAction = asyncAction('messages/DISABLE_MESSAGE');
